import InkindThumbnail from '../InkindThumbnail';
import { gikClassPrefix } from '@gik/core/constants';
import React from 'react';

const blockName = `${gikClassPrefix}-inkind-list-item`;

export interface IInkindListItemProps {
  name: string;
  thumbnail: string;
  isOrganizer: boolean;
  routeId: string;
}

export default function InkindListItem({ name, thumbnail, isOrganizer }: IInkindListItemProps): React.ReactElement {
  return (
    <div className={blockName}>
      <InkindThumbnail thumbnail={thumbnail} isOrganizer={isOrganizer} />
      <span>{name}</span>
    </div>
  );
}
